module.exports = __webpack_public_path__ + "img/SURVEY_MMSE_SM.97d26b68.png";